import React from 'react'
import { Outlet } from 'react-router-dom'
import DashboardLayout from '@/components/Layout/DashboardLayout'

export default function DashboardLayoutPage() {
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  )
}
